export default [
  {
    path: '/app/user/map',
    name: 'mapMarkerUser',
    components: {
      default: () => import('../../views/mapDevice/indexUser.vue')
    }
  },
  {
    path: '/app/user/map/multipleView',
    name: 'multipleViewUser',
    components: {
      default: () => import('../../views/viewMulti/indexUser.vue')
    }
  },
  {
    path: '/app/user/monitoring',
    name: 'MonitorViewUser',
    components: {
      default: () => import('../../views/monitor/indexMonitor.vue')
    }
  },
  {
    path: '/app/user/ftp',
    name: 'ftpPagesUser',
    components: {
      default: () => import('../../views/ftp/indexFtpUser.vue')
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/mapUser.js